module.exports = __webpack_public_path__ + "img/moroccandays.118acbab.jpg";